var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMail = function SvgMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1.436 14q-.614 0-1.025-.396A1.32 1.32 0 0 1 0 12.615v-9.23q0-.592.411-.989A1.42 1.42 0 0 1 1.436 2h13.128q.614 0 1.025.396.411.397.411.989v9.23q0 .592-.411.989a1.42 1.42 0 0 1-1.025.396zM8 8.099.889 3.615v9q0 .23.154.38a.54.54 0 0 0 .393.148h13.128q.24 0 .393-.148a.5.5 0 0 0 .154-.38v-9zm0-.956 6.838-4.286H1.162zM.889 3.615v-.758 9.758q0 .23.154.38a.54.54 0 0 0 .393.148H.889z"
  })));
};
export default SvgMail;